import { render, staticRenderFns } from "./farmList.vue?vue&type=template&id=60df8c3c&scoped=true&"
import script from "./farmList.vue?vue&type=script&lang=js&"
export * from "./farmList.vue?vue&type=script&lang=js&"
import style0 from "./farmList.vue?vue&type=style&index=0&id=60df8c3c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60df8c3c",
  null
  
)

export default component.exports